import React from 'react';
import { Input } from '@app/ui';
import PropTypes from 'prop-types';

const inputStyles = { width: '90%' };

const filterMethod = (filter, row) =>
    !filter.value ||
    row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) !== -1;

const Filter = ({ onChange }) => {
    const handleChange = event => {
        onChange(event.target.value);
    };

    return <Input size="small" onChange={handleChange} style={inputStyles} />;
};

Filter.propTypes = {
    onChange: PropTypes.func.isRequired,
};

const TextFilter = { Filter, filterMethod };
export default TextFilter;
